module.exports = __webpack_public_path__ + "static/media/open-lock.46d9ae16.png";